import { SharedStoreState } from '@core/data-access/models/shared/shared-store.model';
import { sharedReducerKey } from '@core/data-access/store/shared/shared.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TariffUuid } from '@products/models/tariff.model';
import { find, isEmpty, isNil } from 'lodash';

const sharedFeatureSelector = createFeatureSelector<SharedStoreState>(sharedReducerKey);

export const selectSelectedTicketSendingOptions = createSelector(
  sharedFeatureSelector,
  ({ selectedTicketSendingOptions }) => selectedTicketSendingOptions
);

export const selectSelectedTicketSendingOptionByTariffUuid = (tariffUuid: TariffUuid) =>
  createSelector(
    selectSelectedTicketSendingOptions,
    (selectedTicketSendingOptions) => selectedTicketSendingOptions[tariffUuid]
  );

export const selectGoogleMapsApiCache = createSelector(
  sharedFeatureSelector,
  ({ googleMapsApiCache }) => googleMapsApiCache
);

export const selectCachedAddresses = createSelector(selectGoogleMapsApiCache, ({ addresses }) => addresses);

export const selectCachedAddress = (addressId: string) =>
  createSelector(selectCachedAddresses, (cachedAddresses) => cachedAddresses[addressId]);

export const selectCachedCompanies = createSelector(selectGoogleMapsApiCache, ({ companies }) => companies);

export const selectCachedCompany = (companyId: string) =>
  createSelector(selectCachedCompanies, (cachedCompanies) => cachedCompanies[companyId]);

export const selectCachedZipCodes = createSelector(selectGoogleMapsApiCache, ({ zipCodes }) => zipCodes);

export const selectCachedZipCode = (zipCode: string, countryCode: string) =>
  createSelector(selectCachedZipCodes, (cachedZipCodes) => find(cachedZipCodes, { zipCode, countryCode }));

export const selectIsValidZipCode = (zipCode: string, countryCode: string) =>
  createSelector(selectCachedZipCode(zipCode, countryCode), (zipCode) => {
    if (isNil(zipCode)) {
      return null;
    }

    return zipCode.isValid;
  });

export const selectZipCodeCities = (zipCode: string, countryCode: string) =>
  createSelector(selectCachedZipCode(zipCode, countryCode), (zipCode) => {
    if (isEmpty(zipCode)) {
      return null;
    }

    return zipCode.cities;
  });
